import { defineRouting } from 'next-intl/routing';
import { defaultLocale, locales, localePrefix } from './locales';

/**
 * The routing definition alone, for the proxy. `routing.ts` re-exports it together with the
 * `createNavigation` helpers, and those pull next-intl's server config (and with it
 * `next/root-params`) into whatever imports them — which the middleware bundle must not do.
 */
export const routing = defineRouting({
  locales: [...locales],
  defaultLocale,
  localePrefix,
  localeCookie: false,
  localeDetection: false,
  alternateLinks: false,
});
